import { FC, PropsWithChildren, useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router';

import { useApolloClient } from '@apollo/client/react';
import * as Sentry from '@sentry/react';

import { sessionService } from '../../service';
import { AUTH_SESSION_QUERY, AuthSessionQueryResult } from './gql';

const Ensure: FC<PropsWithChildren> = ({ children }) => {
  const apolloClient = useApolloClient();
  const [searchParams, setSearchParams] = useSearchParams();

  const [sessionId, setSessionId] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  const paramSessionId = useMemo(
    () => searchParams.get('sessionId'),
    [searchParams],
  );

  useEffect(() => {
    if (paramSessionId) {
      sessionService.sessionId = paramSessionId;

      setSessionId(paramSessionId);
      setIsLoading(false);

      return;
    }

    apolloClient
      .query<AuthSessionQueryResult>({
        query: AUTH_SESSION_QUERY,
        fetchPolicy: 'network-only',
      })
      .then(({ data }) => {
        if (!data?.payAtPumpUsersSession) {
          return;
        }

        searchParams.set('sessionId', data.payAtPumpUsersSession);
        setSearchParams(searchParams, { replace: true });
      })
      .catch((err) => {
        Sentry.captureException(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [apolloClient, paramSessionId, searchParams, setSearchParams]);

  if (isLoading) {
    return null;
  }

  if (!sessionId) {
    return null;
  }

  return children;
};

export default Ensure;
